export const trackEvent = (category: string, action: string, name: string) => {
  window._paq.push(['trackEvent', category, action, name]);
};
